import type { OutboundReferralKind } from '@/components/patient/referralOutboxData';
import type { ReceiptHistoryItem, RefuseCode } from '@/lib/referral/referralReceipt';

type Translate = (key: string, fallback: string) => string;

export function outboundReferralKindLabel(kind: OutboundReferralKind, t: Translate): string {
  switch (kind) {
    case 'XREF01':
      return t('patients.hospital_referral.outbox_kind_xref01', 'Sygehushenvisning');
    case 'XREF02':
      return t('patients.hospital_referral.outbox_kind_xref02', 'Billeddiagnostisk henvisning');
    case 'XREF06':
      return t('patients.hospital_referral.outbox_kind_xref06', 'Speciallægehenvisning');
    case 'XDIS91':
      return t('patients.hospital_referral.outbox_kind_xdis91', 'Korrespondance (XDIS91)');
    case 'XDIS13':
      return t('patients.hospital_referral.outbox_kind_xdis13', 'Bookingsvar (XDIS13)');
    case 'XDIS01':
      return t('patients.hospital_referral.outbox_kind_xdis01', 'Udskrivningsepikrise (XDIS01)');
    case 'XDIS02':
      return t('patients.hospital_referral.outbox_kind_xdis02', 'Ambulant epikrise (XDIS02)');
    case 'XDIS03':
      return t('patients.hospital_referral.outbox_kind_xdis03', 'Skadestueepikrise (XDIS03)');
    case 'XDIS05':
      return t('patients.hospital_referral.outbox_kind_xdis05', 'Billeddiagnostisk epikrise (XDIS05)');
    case 'GGOP':
      return t('patients.ggop.outbox_kind', 'Genoptræningsplan (GGOP)');
    case 'XDIS18':
      return t('patients.xdis.outbox_kind', 'Udskrivningsrapport (XDIS18)');
    case 'XDIS21':
      return t('patients.xdis.outbox_kind21', 'Plejeforløbsplan (XDIS21)');
    default: {
      const unexpected: never = kind;
      return unexpected;
    }
  }
}

export function refuseCodeLabel(code: RefuseCode, t: Translate): string {
  switch (code) {
    case 'ukendt_lokationsnummer':
      return t('patients.hospital_referral.refuse_ukendt_lokationsnummer', 'Ukendt lokationsnummer');
    case 'problem_med_version':
      return t('patients.hospital_referral.refuse_problem_med_version', 'Problem med version');
    case 'problem_med_modtagerID':
      return t('patients.hospital_referral.refuse_problem_med_modtagerID', 'Problem med modtager-id');
    case 'syntaksfejl':
      return t('patients.hospital_referral.refuse_syntaksfejl', 'Syntaksfejl');
    case 'ikke_specificeret':
      return t('patients.hospital_referral.refuse_ikke_specificeret', 'Ikke specificeret');
    default: {
      const unexpected: never = code;
      return unexpected;
    }
  }
}

export function receiptHistoryKindLabel(item: ReceiptHistoryItem, t: Translate): string {
  switch (item.kind) {
    case 'XCTL01':
      return t('patients.hospital_referral.receipt_history_xctl01', 'Negativ VANS-kvittering (XCTL01)');
    case 'XCTL02':
      return t('patients.hospital_referral.receipt_history_xctl02', 'Negativ kvittering (XCTL02)');
    case 'XCTL03':
      return t('patients.hospital_referral.receipt_history_xctl03', 'Positiv kvittering (XCTL03)');
    default: {
      const unexpected: never = item.kind;
      return unexpected;
    }
  }
}
